import $ from "jquery";

const megaMenu = () => {

    const target = ".wapp-header";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };

    const exec = () => {

    const el = {
        megaMenu: '.wapp-megamenu',
        portioliCoffee: '.portioli-coffee',
        machinesEnAccessories: '.machines-en-accessories',
        portioliCoffeeMenu: '.child-categories-portioli-coffee',
        machinesEnAccessoriesMenu: '.child-categories-machines-en-accessories',
    };

    // FUNCTION FOR MEGA MENU WRAPPER
    function handleMouseover(e) {
        $(e).on('mouseover', function() {
            $(el.megaMenu).addClass('active');
        });
    }

    handleMouseover(el.portioliCoffee);
    handleMouseover(el.machinesEnAccessories);

    // FUNCTION FOR SPECIFY MEGA MENU ITEM
    function handleMouseEvents(triggerSelector, menuSelector) {
        $(triggerSelector).on({
            mouseover: function() {
                $(el.machinesEnAccessoriesMenu).removeClass('active');
                $(el.portioliCoffeeMenu).removeClass('active');
                $(menuSelector).addClass('active');
            },
            mouseout: function() {
                if (!$(menuSelector).is(':hover')) {
                    $(menuSelector).removeClass('active');
                }
            }
        });
    }
    
    handleMouseEvents(el.portioliCoffee, el.portioliCoffeeMenu, el.megaMenu);
    handleMouseEvents(el.machinesEnAccessories, el.machinesEnAccessoriesMenu, el.megaMenu);
    
    
    $(el.portioliCoffeeMenu + ', ' + el.machinesEnAccessoriesMenu).on({
        mouseover: function() {
            $(this).addClass('active');
            $(el.megaMenu).addClass('active');
        },
        mouseout: function() {
            var $menu = $(this);
            if (!$menu.is(':hover')) {
                $menu.removeClass('active');
                $(el.megaMenu).removeClass('active');
            }
        }
    });

    // $(el.portioliCoffee).on({
    //     mouseover: function() {
    //         $(el.megaMenu).addClass('active');
    //     },
    // })
    // $(el.machinesEnAccessories).on({
    //     mouseover: function() {
    //         $(el.megaMenu).addClass('active');
    //     },
    // })
    
    };

    init();
};

try {
    megaMenu();
} catch (error) {
    throw Error(error);
}

